import { render } from "./ReserveInfoDetail.vue?vue&type=template&id=3043f48c&scoped=true"
import script from "./ReserveInfoDetail.vue?vue&type=script&lang=js"
export * from "./ReserveInfoDetail.vue?vue&type=script&lang=js"

import "./ReserveInfoDetail.vue?vue&type=style&index=0&id=3043f48c&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3043f48c"]])

export default __exports__